export type OrganizationAddressResponseArgs = {
  id?: number;
  postal_code?: string;
  location?: string;
  addressee?: string;
};

export type OrganizationAddressArgs = {
  id?: number;
  postalCode?: string;
  location?: string;
  addressee?: string;
};

export const convertOrganizationAddressResponseToArgs = (response: OrganizationAddressResponseArgs) => {
  const args: OrganizationAddressArgs = {
    id: response.id,
    postalCode: response.postal_code,
    location: response.location,
    addressee: response.addressee
  };
  return args;
};

export default class OrganizationAddress {
  id: number | null;
  postalCode: string;
  location: string;
  addressee: string;

  constructor(args?: OrganizationAddressArgs) {
    this.id = args?.id || null;
    this.postalCode = args?.postalCode || '';
    this.location = args?.location || '';
    this.addressee = args?.addressee || '';
  }
}
